import { isBefore } from 'date-fns';
import type {
  AppointmentType,
  BasicContact,
  BuildJsonType,
} from '@bb/domain/dist/types';
import type { HistoryEntry } from '@bb/domain/dist/types/Appointment';

export const formatNonAgentStatus = (
  { nonAgentNotified, date }: HistoryEntry,
  allHistory: HistoryEntry[],
  type: AppointmentType,
  coop: BuildJsonType<BasicContact>,
) => {
  const prevNonAgentNotified = allHistory?.some(
    history =>
      history.nonAgentNotified &&
      isBefore(new Date(history.date), new Date(date)),
  );
  const prevAgentApproved = allHistory?.some(
    history =>
      history.status === 'non_agent_approval' &&
      isBefore(new Date(history.date), new Date(date)),
  );
  const agentApprovedV2 = allHistory?.some(
    history => history.status === 'non_agent_approval',
  );
  const naNameMap: Record<string, string> = {
    Photographer: 'PHOTOGRAPHER',
    'Pest Control': 'PEST CONTROL',
  };
  let naName = naNameMap[type] || 'HOME INSPECTOR/APPRAISER';
  if (!coop.isNotAgent) {
    naName = 'CUSTOM AGENT';
  }
  return `(${naName} ${
    nonAgentNotified ||
    prevNonAgentNotified ||
    prevAgentApproved ||
    // initial `coop.approvedNonAgent` might be wrong, but will eventually be overridden by v2 logic
    // so it is kept here.
    (!agentApprovedV2 && coop.approvedNonAgent)
      ? ''
      : 'NOT'
  } NOTIFIED)`;
};
